import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "filterable-list",
  ref: "parentEl"
}
const _hoisted_2 = {
  class: "filter-bar row q-py-sm",
  ref: "fixedElement",
  style: {"position":"sticky"}
}
const _hoisted_3 = { class: "search col-4 flex align-center q-pr-sm" }
const _hoisted_4 = { class: "filter col-2 flex align-center q-pl-sm" }
const _hoisted_5 = { class: "radio-buttons" }
const _hoisted_6 = { class: "edit col-6 flex align-center justify-end" }
const _hoisted_7 = {
  class: "list",
  ref: "list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_filter_icon = _resolveComponent("filter-icon")!
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_add_icon = _resolveComponent("add-icon")!
  const _component_close_icon = _resolveComponent("close-icon")!
  const _component_tick_icon = _resolveComponent("tick-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["list-view", {expanded: _ctx.expanded}]),
    style: _normalizeStyle({ height: `${_ctx.height}` })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_q_input, {
            "model-value": _ctx.searchValue,
            "onUpdate:modelValue": _ctx.emitSearchQuery,
            label: "Search",
            outlined: "",
            dense: ""
          }, null, 8, ["model-value", "onUpdate:modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_q_btn, {
            unelevated: "",
            rounded: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_filter_icon, { left: "" }),
              _cache[4] || (_cache[4] = _createElementVNode("span", null, " Filters", -1)),
              _createVNode(_component_q_menu, {
                class: "filters padded-menu",
                offset: [0, 12]
              }, {
                default: _withCtx(() => [
                  _cache[3] || (_cache[3] = _createElementVNode("p", null, "Show", -1)),
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterValues, (filter) => {
                      return (_openBlock(), _createBlock(_component_q_radio, {
                        "model-value": _ctx.filterValue,
                        "onUpdate:modelValue": _ctx.emitFilter,
                        set: () => 'everything',
                        label: filter.label,
                        val: filter.val,
                        size: "xs",
                        dense: ""
                      }, null, 8, ["model-value", "onUpdate:modelValue", "label", "val"]))
                    }), 256))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          (!_ctx.readonly)
            ? _renderSlot(_ctx.$slots, "actions", {
                key: 0,
                emitEvent: (e) => _ctx.$emit(e)
              }, () => [
                _createVNode(_component_q_btn, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('add'))),
                  unelevated: "",
                  rounded: "",
                  outline: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_add_icon, {
                      left: !_ctx.isMobile
                    }, null, 8, ["left"]),
                    _withDirectives(_createElementVNode("span", null, "Product", 512), [
                      [_vShow, !_ctx.isMobile]
                    ])
                  ]),
                  _: 1
                }),
                (_ctx.editing)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      class: "q-mr-md q-ml-md",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel'))),
                      flat: "",
                      outline: "",
                      unelevated: "",
                      rounded: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_close_icon, { left: "" }),
                        _cache[5] || (_cache[5] = _createElementVNode("span", null, "Cancel", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.editing)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 1,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('save'))),
                      unelevated: "",
                      rounded: "",
                      color: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_tick_icon, { left: "" }),
                        _cache[6] || (_cache[6] = _createElementVNode("span", null, "Save", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], true)
            : _createCommentVNode("", true)
        ])
      ], 512),
      _createElementVNode("div", _hoisted_7, [
        _renderSlot(_ctx.$slots, "filterable-list", {}, undefined, true)
      ], 512)
    ], 512),
    _renderSlot(_ctx.$slots, "after", {}, undefined, true)
  ], 6))
}